import {Injectable} from '@angular/core';
import axios from "axios";
import {AuthService} from "./auth.service";
import {
  APIResponse,
  AssociatedEvidencesResp,
  IncidentRecord,
  IncidentSearchParams,
  LinkReportIncidentReq, NIBIN_AdditionalInfoEvidence,
  ReportAssocReq,
  ReportRecord, ReportUpdateStatus
} from "../NIBINInterface";
import {MatSnackBar} from "@angular/material/snack-bar";
import {formatDate} from "@angular/common";


@Injectable()
export class ReportService {
  constructor(private authService:AuthService, private matSnackBar: MatSnackBar) {}

  public async GetLinkAnalysisReportURL(ReportID:string) : Promise<string | null> {
    try{
      let result = await axios.get('/NIBIN/Report/GetLinkAnalysisReportURL?ReportID='+ReportID,{headers:{authToken:this.authService.getUser().apikey}})
      let apiResult:APIResponse = result.data

      if(apiResult.MessageCode==200){
        return apiResult.AnyData;
      }

      return null;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to load Link Analysis", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return null
    }

  }

  public async GetTimeLineReportURL(ReportID:string) : Promise<string | null> {
    try{
      let result = await axios.get('/NIBIN/Report/GetTimeLineReportURL?ReportID='+ReportID,{headers:{authToken:this.authService.getUser().apikey}})
      let apiResult:APIResponse = result.data

      if(apiResult.MessageCode==200){
        return apiResult.AnyData;
      }

      return null;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to load Link Analysis", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return null
    }

  }

  public async getLatestReport(lab:string) : Promise<ReportRecord[]> {
    try{
      let result = await axios.get('/NIBIN/Report/getLatestReports?lab='+lab,{headers:{authToken:this.authService.getUser().apikey}})
      let rawData:ReportRecord[] = result.data
      for(let r of rawData){
        if(r.Incidents)
          for(let o of r.Incidents){
            o.SelectedForReport=false
          }
      }

      return rawData;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to load latest NIBIN Reports", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return []
    }

  }

  public async searchReports(params:IncidentSearchParams) : Promise<ReportRecord[]> {
    try{
      let result = await axios.post('/NIBIN/Report/searchReports',params, {headers:{authToken:this.authService.getUser().apikey}})
      let rawData:ReportRecord[] = result.data
      for(let r of rawData){
        if(r.Incidents)
          for(let o of r.Incidents){
            o.SelectedForReport=false
          }
      }
      return rawData;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to search NIBIN Reports", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return []
    }

  }

  public async saveRptToDB(params_Raw:ReportRecord): Promise<ReportRecord>{
    let params:ReportRecord = JSON.parse(JSON.stringify(params_Raw))
    try{
      if( params.Incidents){
        for(let i of params.Incidents){
          i.SelectedAsPrimary = false
        }
      }
      let result = await axios.post('/NIBIN/Report/add_report',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Save Report", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return params;
    }
  }

  public async updateReportDB(params_Raw:ReportRecord): Promise<ReportRecord>{
    //Copy and Set SelectedForAssoc to null as it may lead to save error and is not needed in this controller
    let params:ReportRecord = JSON.parse(JSON.stringify(params_Raw))
    try{
      if( params.Incidents){
        for(let i of params.Incidents){
          i.SelectedAsPrimary = false
          if( i.Ballistics)
            for(let b of i.Ballistics)
              b.SelectedForAssoc = null
          if(i.Weapon)
            for(let w of i.Weapon)
              w.SelectedForAssoc = null
        }
      }

      let result = await axios.post('/NIBIN/Report/update_report',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Update Report", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return params;
    }
  }

  public async linkIncToReport(params:LinkReportIncidentReq): Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Report/link_inc_to_report',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to add a Incident to Report", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }
  }

  public async removeLinkIncToReport(params:LinkReportIncidentReq): Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Report/rm_link_inc_to_report',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Remove a Incident from Report", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }
  }

  public async addAssociation(params:ReportAssocReq): Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Report/add_association',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to add Weapon or Ballistics Association", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }
  }

  public async removeAssociation(params:ReportAssocReq): Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Report/rm_association',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Remove Weapon or Ballistics Association", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }
  }

  public async updateReportStatus(params:ReportUpdateStatus): Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Report/update_status',params, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Update Report Status", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }

  }

  public async getAssociatedEvidences(EID:string, EType:string): Promise<AssociatedEvidencesResp>{
    try{
      let result = await axios.post('/NIBIN/Report/getAssociatedEvidences?EID='+EID+'&EType='+EType,{}, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Load Associated Evidences", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }

  }

  public async DeleteReport(ReportID:string): Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Report/delete_report?ReportID='+ReportID, {}, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Delete Report", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }
  }

  public async RescindReport(ReportID:string): Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Report/rescind_report?ReportID='+ReportID, {}, {headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      this.matSnackBar.open("Error Trying to Rescind Report", 'CLOSE', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return {}
    }
  }

  public sortReportsIncidents( a:IncidentRecord, b:IncidentRecord ) {
    if(a.OccurrenceDate && b.OccurrenceDate){
      if ( a.OccurrenceDate > b.OccurrenceDate ){
        return -1;
      }
      if ( a.OccurrenceDate < b.OccurrenceDate ){
        return 1;
      }
      if(a.OccurrenceDate == b.OccurrenceDate){
        if(a.ID && b.ID && a.ID > b.ID)
          return -1;
        if(a.ID && b.ID && a.ID < b.ID)
          return 1;
      }
    }
    return 0;
  }

  public makeIncidentEvidenceLines(i: IncidentRecord) : NIBIN_AdditionalInfoEvidence[]{
    let tResult: NIBIN_AdditionalInfoEvidence[] = [];
    if(i.Weapon){
      for(let w of i.Weapon){
        let evTxt:string = ""
        if(w.MAKE)
          evTxt+= w.MAKE
        if(w.MODEL)
          evTxt+=" MODEL "+ w.MODEL
        if(w.CALIBER)
          evTxt+=" "+w.CALIBER
        if(w.SERIAL_NUMBER)
          evTxt+=" Serial# "+ w.SERIAL_NUMBER
        if(w.SelectedForAssoc && w.EvidenceMarker)
          evTxt+="  "+ w.EvidenceMarker + (w.PreviousHit? "  Hit Ref #" + w.PreviousHit: "")
        if(w.CT_Ghost_Gun)
          evTxt+=" (GHOST GUN)"
        if(w.SearModifyFlag)
          evTxt+=" (SEAR MODIFIED)"
        if(w.DTOFCOLLECTION)
          evTxt+=" \r\nDate of Collection : "+ formatDate(w.DTOFCOLLECTION,'MM-dd-yyyy','en-US')
        if(w.DTOFSUBMISSION)
          evTxt+=" \r\nDate of Submission: "+ formatDate(w.DTOFSUBMISSION,'MM-dd-yyyy','en-US')
        if(!w.SelectedForAssoc && w.PreviousHit)
          evTxt+=(w.PreviousHit? "\r\nPrevious Hit Ref #" + w.PreviousHit: "" )+ " "+ w.EvidenceMarker

        if(w.Notes)
          evTxt+=" \r\nNotes: "+ w.Notes
        /*if(w.CALIBER)
          evTxt+=w.CALIBER
        if(w.MAKE)
          evTxt+=" "+ w.MAKE
        if(w.W_CLASS)
          evTxt+=" "+ w.W_CLASS
        if(w.MODEL)
          evTxt+=" "+ w.MODEL
        if(w.SERIAL_NUMBER)
          evTxt+=" Serial# "+ w.SERIAL_NUMBER
        if(w.EvidenceMarker)
          evTxt+=" "+ w.EvidenceMarker
        if(w.DTOFCOLLECTION)
          evTxt+=" Date of Collection : "+ formatDate(w.DTOFCOLLECTION,'MM-dd-yyyy','en-US')
        if(w.DTOFSUBMISSION)
          evTxt+=" Date of Submission: "+ formatDate(w.DTOFSUBMISSION,'MM-dd-yyyy','en-US')
        if(w.Notes)
          evTxt+=" Notes: "+ w.Notes*/

        tResult.push({EV_ID:w.ID, Assoc_Type:w.Assoc_Type, SelectedForAssoc:w.SelectedForAssoc? w.SelectedForAssoc:false, EV_Type:'WEAPON',EV_Text:evTxt?.toUpperCase()})
      }
    }
    if(i.Ballistics){
      for(let b of i.Ballistics){
        let evTxt:string = ""
        if(b.Item_Quantity)
          evTxt+="("+b.Item_Quantity+")"
        if(b.Caliber_Type)
          evTxt+=" "+ b.Caliber_Type
        if(b.Headstamp)
          evTxt+=" "+ b.Headstamp
        if(b.VGID_CPart)
          evTxt+=" DISCHARGED "+ b.VGID_CPart
        if(b.CL_LG)
          evTxt+=" CL-LG: "+ b.CL_LG
        if(b.CL_Twist)
          evTxt+=" CL-Twist: "+ b.CL_Twist
        if(b.CL_Type)
          evTxt+=" CL-Type: "+ b.CL_Type

        if(b.SelectedForAssoc && b.EvidenceMarker)
          evTxt+="  " + b.EvidenceMarker + (b.PreviousHit? "  Hit Ref #" + b.PreviousHit: "")
        if(b.DTOFCOLLECTION)
          evTxt+=" \r\nDate of Collection: "+ formatDate(b.DTOFCOLLECTION,'MM-dd-yyyy','en-US')
        if(b.DTOFSUBMISSION)
          evTxt+=" \r\nDate of Submission: "+ formatDate(b.DTOFSUBMISSION,'MM-dd-yyyy','en-US')
        if(!b.SelectedForAssoc && b.PreviousHit)
          evTxt+=(b.PreviousHit? "\r\nPrevious Hit Ref #" + b.PreviousHit: "" )+ " "+ b.EvidenceMarker

        if(b.Notes)
          evTxt+="\r\nNotes: "+ b.Notes

        tResult.push({EV_ID:b.ID, Assoc_Type:b.Assoc_Type, SelectedForAssoc:b.SelectedForAssoc? b.SelectedForAssoc:false, EV_Type:'BALLISTIC',EV_Text:evTxt?.toUpperCase()})
      }
    }
    tResult.sort(function (x, y) {
      return  (x.SelectedForAssoc === y.SelectedForAssoc) ? 0 : x.SelectedForAssoc ? -1 : 1;
    });
    return tResult;
  }

  public updateEvidenceMasters(Incidents: IncidentRecord[]){
    for(let i of Incidents){
      //Update the Incidents Weapon,Ballistic Master Record
      if(i.RPT_AdditionalInfoEvidence) {
        for (let e of i.RPT_AdditionalInfoEvidence) {
          if(e.EV_Type === "WEAPON"){
            let wObj = i.Weapon?.find(w => {
              if(w.ID)
                return w.ID==e.EV_ID;
              return 0;
            });
            if(wObj){
              wObj.SelectedForAssoc = e.SelectedForAssoc
              wObj.Assoc_Type = e.Assoc_Type
            }

          }
          if(e.EV_Type === "BALLISTIC"){
            let bObj = i.Ballistics?.find(b => {
              if(b.ID)
                return b.ID==e.EV_ID;
              return 0;
            });
            if(bObj){
              bObj.SelectedForAssoc = e.SelectedForAssoc
              bObj.Assoc_Type = e.Assoc_Type
            }
          }
        }
      }

      //Rebuild the Additional Info list
      i.RPT_AdditionalInfoEvidence = this.makeIncidentEvidenceLines(i)
    }
  }

}
